export default __webpack_public_path__ + "static/char-05-anr-515caa59dfa8b586b056dc5ee5ebeacd.gif";